import React from 'react';
import { useHistory } from 'react-router-dom';
import { ArrowLeftOutlined } from '@ant-design/icons/lib/icons';
import styled from 'styled-components';

import { getCategoryLabel } from 'leash/components/packagesHeader/PackagesHeader';
import { usePackagesContext } from 'leash/context/packages/PackagesContext';
import { PackagesRouteParams } from 'leash/pages/packages/Packages';
import { LeashRoutes } from 'leash/utilities/const';
import { toPluralOrSingular } from 'utilities/text/text';

const PackageTitleStyled = styled.div`
  font-weight: normal;
`;

interface PackagesTitleProps extends PackagesRouteParams {
  resultsCounts?: number;
}

export function PackagesTitle({ category, query, resultsCounts }: PackagesTitleProps) {
  if (!category) return <>All Packages</>;
  const { dispatch } = usePackagesContext();
  const history = useHistory();

  const handleExitSearchMode = () => {
    history.push(LeashRoutes.Packages);
    dispatch({ type: 'SET_FETCH_PACKAGES' });
    dispatch({ type: 'FILTER_PACKAGES', payload: {} });
  };

  return (
    <PackageTitleStyled data-testid="packages-title">
      <ArrowLeftOutlined onClick={handleExitSearchMode} />
      &nbsp;&nbsp;
      {getCategoryLabel(category)}: <strong>{query}</strong> ({resultsCounts}&nbsp;
      {toPluralOrSingular('result', resultsCounts)})
    </PackageTitleStyled>
  );
}
